import { render, staticRenderFns } from "./ProgressItems.vue?vue&type=template&id=6f89e656&"
import script from "./ProgressItems.vue?vue&type=script&lang=ts&"
export * from "./ProgressItems.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSimpleTable,VSpacer})
